<template>
  <div id="login-bg">
    <div class="text-center pt-6">
      <img class="mx-auto" src="../assets/img/logologin.png" />
      <h1 class="text-white text-lg font-bold">
        هلدینگ گردشگری تخت جمشید شاندیز
      </h1>
      <p class="text-gray-300 text-xs mt-2">
        لطفا شماره موبایل خود را وارد نمایید
      </p>
    </div>
    <div class="w-full p-8">
      <form
        action=""
        @submit.prevent="showVerifyInput ? verifyPhone() : login()"
      >
        <VInput
          type="tel"
          class="w-full mt-2 text-center"
          placeholder="شماره موبایل"
          v-model="inputPhone.value"
          :disabled="showVerifyInput"
          :error="inputPhone.error"
          @keydown="inputPhone.error = ''"
          required
        />
        <span class="text-xs text-red-500" v-if="inputPhone.error">{{
          inputPhone.error
        }}</span>

        <VInput
          type="number"
          class="w-full mt-2 text-center"
          placeholder="کد تایید"
          v-model="verificationCode"
          :disabled="!showVerifyInput"
          required
          v-if="showVerifyInput"
        />

        <VButton
          class="w-full mt-2 shadow-lg bg-ColorNerkh"
          type="submit"
          :loading="loading"
          >ورود</VButton
        >
      </form>
    </div>
  </div>
</template>

<script>
import VInput from "@/components/General/VInput";
import VButton from "@/components/General/VButton";

export default {
  name: "LoginPage",
  components: { VButton, VInput },
  data() {
    return {
      loading: false,
      inputPhone: {
        value: "",
        error: "",
      },
      verificationCode: "",
      showVerifyInput: false,
      reLogin: false,
    };
  },
  created() {
    this.reLogin = this.$route.query.reLogin;
  },
  methods: {
    login() {
      this.loading = true;
      this.inputPhone.value = this.inputPhone.value.replace(/[۰-۹]/g, (value) =>
        "۰۱۲۳۴۵۶۷۸۹".indexOf(value)
      );
      if (this.validatePhoneNumber()) {
        this.$store
          .dispatch("login", this.inputPhone.value)
          .then((resp) => {
            this.showVerifyInput = true;
            this.verificationCode = resp;
            this.$swal({
              icon: "success",
              title: "موفق",
              text: "کد تایید برای شما پیامک شد.",
              confirmButtonColor: "#fcd34d",
              confirmButtonText: "باشه",
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    verifyPhone() {
      this.loading = true;
      let params = {
        phone: this.inputPhone.value,
        verificationCode: this.verificationCode,
      };
      this.$store
        .dispatch("verifyPhone", params)
        .then(() => {
          this.$router.push("/");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    validatePhoneNumber() {
      let result = true;

      if (!this.inputPhone.value) {
        this.inputPhone.error = "لطفا شماره خود را وارد کنید";

        result = false;
      } else if (this.inputPhone.value.length !== 11) {
        this.inputPhone.error = "شماره همراه باید 11 رقم باشد";

        result = false;
      } else if (this.inputPhone.value.substr(0, 2) !== "09") {
        this.inputPhone.error = "شماره همراه باید با 09 شروع شود";

        result = false;
      }

      return result;
    },
  },
};
</script>

<style scoped>
/* .login_bg {
  width: 100%;
  min-height: 100vh;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-image: url(../../assets/img/bg_login.jpg);
  z-index: 1;
} */

#login-bg {
  content: "";
  background-image: url("../assets/img/bg_login.jpg");
  @apply w-screen h-screen bg-no-repeat bg-cover;
}
</style>
